// extracted by mini-css-extract-plugin
export default {"SpinnerDefault":"spinner_SpinnerDefault__2eOOp","SpinnerLarge":"spinner_SpinnerLarge__1uQQx","SpinnerSeasonal":"spinner_SpinnerSeasonal__2dX2c"};